import { Alert } from '@creditornot/cb-alert';
import { typographyCss } from '@creditornot/cb-ingredients';
import React, { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import sendErrorReport from 'common/utils/sendErrorReport';

type Props = {
  className?: string;
  children: ReactNode;
};

const Root = styled.div`
  padding: 24px;
`;

const ContactSupport = styled.div`
  margin-block-start: 16px;
  ${typographyCss.Body3}
`;

const CollectionListErrorBoundary = ({ className, children }: Props) => (
  <ReactErrorBoundary
    onError={(error, info) => {
      sendErrorReport(error, 'boundary', { info });
    }}
    FallbackComponent={({ error }) => (
      <Root className={className}>
        <Alert variant="error">
          {error instanceof Error ? error.message : <FormattedMessage id="global-error-message.unknown-error" />}
        </Alert>
        <ContactSupport>
          <FormattedMessage id="global-error-message.contact-support-prompt" />
        </ContactSupport>
      </Root>
    )}
  >
    {children}
  </ReactErrorBoundary>
);

export default CollectionListErrorBoundary;
